<template>
  <el-dialog :title="$t('customer::customer-list::tagRule')" :visible.sync="visible" width="500px">
    <div>
      <div class="label-title">
        {{ $t('customer::customer-list::tagAttr') }}
        <el-tooltip placement="right" :content="$t('customer::customer-list::tagTips')">
          <i class="el-icon-question" style="color: #999"></i>
        </el-tooltip>
      </div>
      <div>
        {{ $t('customer::customer-list::exceed') }}
        <el-input-number v-model="form.lostValue" :precision="0" :controls="false" class="input-wrap" @blur="onBlur"></el-input-number>
        {{ $t('customer::customer-list::exceedDays') }}
      </div>
    </div>
    <div slot="footer">
      <el-button type="" @click="visible = false">{{ $t('system::common::btn::cancel') }}</el-button>
      <el-button type="primary" @click="submit" :loading="loading">{{ $t('system::common::btn::confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getReportSetting, postReportSetting } from '@/server/user'
export default {
  data() {
    return {
      visible: false,
      form: {
        lostValue: 180
      },
      loading: false
    }
  },
  props: {
    value: {}
  },
  methods: {
    async getTagRule() {
      const { data } = await getReportSetting(2)
      if (data.code === this.$code && data.data.config) {
        console.log(data.data)
        this.form = { ...this.form, ...JSON.parse(data.data.config) }
      }
    },
    async submit() {
      if (!this.form.lostValue) return this.$message.warning(this.$t('customer::customer-list::messageTips'))
      this.loading = true
      let config = JSON.stringify(this.form)
      const { data } = await postReportSetting({ type: 2, config: config, status: 1 })
      this.loading = false
      if (data.code === this.$code) {
        this.$message.success(this.$t('system::tip::change_success'))
        this.visible = false
      }
    },
    onBlur() {
      if (this.form.lostValue < 30) {
        this.$message.warning(this.$t('customer::customer-list::messageTips'))
        this.form.lostValue = 30
      }
    }
  },
  watch: {
    visible(val) {
      this.$emit('input', val)
      if (val) {
        this.getTagRule()
      }
    },
    value(val) {
      this.visible = val
    }
  }
}
</script>

<style scoped lang="scss">
.label-title {
  margin-bottom: 20px;
  font-weight: 600;
}
.input-wrap {
  width: 120px;
  margin: 0 5px;
}
</style>
